export const SN_ROOT = 'root'
export const USER_TOKEN_INVALIDATE_LOCK_CHANGED = SN_ROOT + '/USER_TOKEN_INVALIDATE_LOCK_CHANGED'
export const RESET_USER_TOKEN_INVALIDATION = SN_ROOT + '/RESET_USER_TOKEN_INVALIDATION'
